import React from "react";

import { motion } from "framer-motion";
import { fadeIn } from "../variants";

import { AnimatePresence } from "framer-motion";

import "./Projects.css";

import { useEffect, useState } from "react";

// 在项目组件中导入该函数
import { getProjects } from "./api"; // 路径按你自己的结构来

import { useNavigate } from "react-router-dom";

import ReactMarkdown from "react-markdown";

const Projects = () => {
  const [hoveredProject, setHoveredProject] = useState(null); // 当前鼠标悬停目标
  const [visibleProject, setVisibleProject] = useState(null); // 实际展示在卡片上的内容

  const [projects, setProjects] = useState([]);
  const [touchActive, setTouchActive] = useState(null);

  // 路由
  const navigate = useNavigate();

  useEffect(() => {
    if (hoveredProject) {
      // 延迟切换项目，制造淡出-淡入的感觉
      const timeout = setTimeout(() => {
        setVisibleProject(hoveredProject);
      }, 100); // 100ms 的间隔可以让 exit 动画播放完成

      return () => clearTimeout(timeout); // 清除上次定时器
    } else {
      // 鼠标离开时延迟清除
      const timeout = setTimeout(() => {
        setVisibleProject(null);
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [hoveredProject]);

  useEffect(() => {
    async function fetchProjects() {
      try {
        const data = await getProjects();
        setProjects(data.data); // Strapi 返回的是 { data: [...] }
      } catch (err) {
        console.error("Failed to load projects", err);
      }
    }

    fetchProjects();
  }, []);

  const handleTouchStart = (project) => {
    setTouchActive(project.id);
  };

  const handleTouchEnd = () => {
    setTouchActive(null);
  };

  const [hovered, setHovered] = useState(false);

  const extractFirstParagraphText = (markdown) => {
    const match = markdown.match(/^.*$/m); // 只取第一行
    return match ? match[0] : "";
  };

  return (
    <section className="section min-h-[100vh] lg:min-h-[100vh] flex items-center" id="projects">
      <div className="container mx-auto">
        <div className="flex flex-col items-center lg:flex-row gap-y-10 lg:gap-x-10">
          <div className="flex-1 flex flex-col items-center">
            <motion.div
              variants={fadeIn("right", 0.5)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.3 }}
              className="flex-1 flex flex-col items-center"
            >
              <h2 className="font-bold text-[40px]">Recent Projects</h2>
              <p className="mb-6">Here are the recent works I have done.</p>

              <button
                onClick={() => navigate("/projects")}
                className={
                  "inline-flex items-center gap-x-2 bg-transparent border-none p-0 text-inherit  text-3xl font-bold lg:hidden"
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="3.5"
                  stroke="currentColor"
                  className="size-[30px]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
                  />
                </svg>
                <p>More projects</p>
              </button>

              <div className="hidden lg:flex relative min-h-[200px] w-full justify-center">
                <AnimatePresence mode="wait">
                  <button
                    onClick={() => navigate("/projects")}
                    className={`${
                      visibleProject ? "hidden" : ""
                    } inline-flex items-center gap-x-2 bg-transparent border-none p-0 text-inherit cursor-pointer opacity-70 hover:opacity-100 transition-opacity duration-300 text-3xl font-bold`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="3.5"
                      stroke="currentColor"
                      className="size-[30px]"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
                      />
                    </svg>
                    <p>More projects</p>
                  </button>

                  {visibleProject && (
                    <motion.div
                      key={visibleProject.id}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: 20 }}
                      transition={{ duration: 0.3 }}
                      className="hidden lg:block bg-white/10 p-4 pb-2 rounded-lg shadow-md dark:shadow-[0_4px_8px_rgba(255,255,255,.25)] max-w-[450px] w-full"
                    >
                      <img
                        src={
                          visibleProject.cover?.formats?.small?.url ||
                          visibleProject.cover?.url ||
                          ""
                        }
                        alt="Project Cover"
                        className="w-full h-[200px] rounded object-cover mb-[25px]"
                      />
                      <div className="break-all">
                        <h4 className="text-xl font-bold mb-1 text-center">
                          {visibleProject.hometitle}
                        </h4>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </motion.div>
          </div>

          <div className="flex-1">
            {/* projects */}
            <div className="flex-1">
              {projects.slice(0, 5).map((project, index) => {
                const attrs = project;
                return (
                  <motion.div
                    key={project.id}
                    variants={fadeIn("left", 0.5)}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: false, amount: 0.7 }}
                  >
                    <div
                      className={`group border-t border-black dark:border-white h-[120px] lg:h-[146px] flex items-center project-item cursor-pointer ${
                        touchActive === project.id ? "touch-active" : ""
                      }`}
                      onMouseEnter={() => setHoveredProject(attrs)}
                      onMouseLeave={() => setHoveredProject(null)}
                      onTouchStart={() => handleTouchStart(project)}
                      onTouchEnd={handleTouchEnd}
                      onClick={() =>
                        navigate("/projects", {
                          state: { projectId: attrs.id },
                        })
                      }
                    >
                      <div className=" flex items-center justify-between w-full h-full px-4 py-2 hover:bg-white/10 transition-colors ">
                        <div className="max-w-[476px] break-all">
                          <h3 className="text-[35px] lg:text-[40px] font-semibold mb-1">
                            {attrs.hometitle}
                          </h3>
                          <ReactMarkdown
                            components={{
                              p: ({ children }) => (
                                <p className="font-secondary text-[20px] leading-tight line-clamp-1">
                                  {children}
                                </p>
                              ),
                            }}
                          >
                            {extractFirstParagraphText(attrs.summary || "")}
                          </ReactMarkdown>
                        </div>

                        {/* 右边竖着的日期 */}

                        {/* 初始显示 */}
                        <div className="writing-mode-vertical group-hover:hidden flex items-center justify-center h-full text-[24px]">
                          {attrs.date}
                        </div>
                        {/* 初始隐藏，hover 后显示 + 滚动 */}
                        <div className="hidden flex-col gap-y-10 group-hover:flex group-hover:animate-scrollUp text-[24px]">
                          {Array(2) // 重复2遍
                            .fill(null)
                            .flatMap(() =>
                              Array(7)
                                .fill(attrs.date)
                                .map((text, i) => (
                                  <div
                                    key={Math.random()} // 要保证唯一 key
                                    className="writing-mode-vertical group-hover:text-green-500
                                      dark:group-hover:text-red-700"
                                  >
                                    {text}
                                  </div>
                                ))
                            )}
                        </div>
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
